import CoreDefault from "core/Defaults";
import LightGallery from 'lightgallery/react';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgRotate from 'lightgallery/plugins/rotate';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
// actions
import { TGallery } from "../type";
import "../../RMDRGallery/Gallery01Style.scss";
import { FaSearch } from "react-icons/fa";
import { useState } from "react";
import IApplicationDocument from "cms/interfaces/IApplicationDocument";
import IApplicationDocumentList from "cms/interfaces/IApplicationDocumentList";


function Gallery01 ( props:TGallery ) {
    console.log("Gallery01.rendered: ", props);

    const [ images ]  = useState<IApplicationDocument[]|IApplicationDocumentList[]|undefined>(props.resources?.filter((item) => item.resourceTypeId === props.resourceType)?.map((item) => item.applicationDocument));

    return (
        <>
        
            {
                images ? (
                    <div className={`rmdr-gallery-01 ${props.className}`}>
                        <LightGallery
                            galleryId="lightgallery"
                            plugins={[lgThumbnail, lgZoom, lgRotate, lgFullscreen, lgShare]}
                            // mode="lg-fade"
                            // pager={false}
                            thumbnail={true}
                            animateThumb={true}
                            mobileSettings={{
                                controls: false,
                                showCloseIcon: false,
                                download: false,
                                rotate: false,
                            }}
                            elementClassNames={`list-unstyled ${props.galleryClassName}`}
                        >
                            {
                                images.map((item, index) => (
                                    <div key={`index-${index}`} className={`lg-react-element-item ${props.itemWrapperClassName}`} data-src={`${CoreDefault.cdn}/${item.filePath}`}>
                                        <a href="#" title={item.name} className={props.itemClassName}>
                                            <img 
                                                alt={item.name} 
                                                title={item.name} 
                                                src={`${CoreDefault.cdn}/${item.filePath}`} 
                                                className="img-responsive" 
                                            />
                                            <div className="rmdr-gallery-poster">
                                                <FaSearch className="tw-text-2xl !tw-text-white" />
                                            </div>
                                        </a>
                                    </div>
                                ))
                            }
                        </LightGallery>
                    </div>
                ) :null
            }
        </>
    )
    
}

export default Gallery01;
